import { Box, Typography, Button, useMediaQuery } from "@mui/material";
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import { theme } from "../Theme";

export const Kontakt: React.FC = () => {
    const biggerThanSm = useMediaQuery(theme.breakpoints.up('sm'));

    return (
        <Box  alignItems='center' justifyContent='start' textAlign="left" display="flex" flexDirection="column" marginTop={biggerThanSm?'3%':'5%'} marginBottom={biggerThanSm?'3%':'5%'}>
        <div style={{border: '3px dotted #FFF', padding: biggerThanSm?'10% 5% 10% 5%':'20% 10% 20% 10%'}}>
      <Typography variant={biggerThanSm?"h5":'h6'} color="primary" component="h2" textAlign='center' paddingBottom={biggerThanSm?'40px':'20px'}>
        <strong>So erreichst du mich:</strong>
        </Typography>  
        <Box
          display="flex"
          flexDirection='column'
          marginRight="1rem"
          marginBottom="1rem"
        >
      <Button variant="outlined" style={{margin: '5px 5px 0 5px'}} startIcon={<InstagramIcon />} onClick={() => window.open('https://instagram.com/fiona.paola','_blank')}>
        <Box component="i" marginRight=".5rem" />
        <Typography>
          Instagram
        </Typography>
        
      </Button>
      <Typography color={'primary'} style={{margin: '0 20px 20px 20px'}} borderBottom={'1px dotted #053a4a'} textAlign={'center'} variant="caption">
            @fiona.paola
        </Typography>
      <Button variant="outlined" style={{margin: '5px 5px 0 5px'}} startIcon={<EmailIcon />} onClick={() => window.open('mailto:fionakrause@gmx.de','_blank')}>
        <Box component="i" marginRight=".5rem" />
          Email
      </Button>
      <Typography color={'primary'} style={{margin: '0 20px 20px 20px'}} borderBottom={'1px dotted #053a4a'} textAlign={'center'} variant="caption">
            fionakrause@gmx.de
      </Typography>
    </Box>
    </div>
      </Box>
    )
}